import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const globalSettingsSystemRolesActorsGroupsRoute: InvariantRoute = {
	name: 'global-settings-system-roles-actors-groups',
	path: '/secure/project/GroupRoleActorAction.jspa',
};
